import { Button } from '../ui';

export interface IdealParams { tpaFt: number; downwindNm: number; turnRadiusNm: number; direction: 'left' | 'right' | null; visible: boolean }
export default function IdealControls({ p, onChange, onReset }: { p: IdealParams; onChange: (p: IdealParams) => void; onReset: () => void }) {
  const slider = (label: string, key: 'tpaFt' | 'downwindNm' | 'turnRadiusNm', min: number, max: number, step: number, unit: string) => (
    <label className="block text-xs">
      <div className="flex justify-between text-dim"><span>{label}</span><span className="hud text-fog">{p[key]} {unit}</span></div>
      <input type="range" min={min} max={max} step={step} value={p[key]} onChange={e => onChange({ ...p, [key]: Number(e.target.value) })} className="w-full" />
    </label>
  );
  return (
    <div className="px-4 py-3 space-y-2">
      <div className="flex gap-2">
        <Button size="sm" variant={p.visible ? 'primary' : 'default'} onClick={() => onChange({ ...p, visible: !p.visible })}>{p.visible ? 'Ghost on' : 'Ghost off'}</Button>
        <Button size="sm" onClick={() => onChange({ ...p, direction: p.direction === 'right' ? 'left' : 'right' })}>{p.direction ?? 'auto'} pattern</Button>
        <Button size="sm" variant="ghost" onClick={onReset}>reset</Button>
      </div>
      {slider('Pattern altitude', 'tpaFt', 600, 1500, 50, 'ft')}
      {slider('Downwind distance', 'downwindNm', 0.4, 1.5, 0.05, 'nm')}
      {slider('Turn radius', 'turnRadiusNm', 0.15, 0.5, 0.05, 'nm')}
    </div>
  );
}
